import React, { useState, useEffect } from 'react';
import { Modal, message, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { MindMapContext } from '../../Context/contex';
import { templateService } from '../../Api/api';
import './TemplateActiveToggle.css';

const TemplateActiveToggle = () => {
    const { documentId } = useParams();
    const { templateData, setTemplateData, setSavingData, isTemplateDocument } = MindMapContext();
    const [isActive, setIsActive] = useState(Boolean(templateData?.isActive));

    useEffect(() => {
        setIsActive(Boolean(templateData?.isActive));
    }, [templateData?.isActive]);

    const handleToggle = async (newActiveStatus) => {
        const statusText = newActiveStatus ? 'activate' : 'deactivate';
        Modal.confirm({
            title: `${statusText.charAt(0).toUpperCase() + statusText.slice(1)} Template`,
            content: `Are you sure you want to ${statusText} this template?`,
            okText: statusText.charAt(0).toUpperCase() + statusText.slice(1),
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    if (documentId) {
                        const res = await templateService.updateTemplate({ templateId: documentId, data: { isActive: newActiveStatus.toString() }, dispatch: setSavingData });
                        if (res?.data?.data) {
                            setTemplateData(res.data.data);
                            setIsActive(res.data.data.isActive ?? newActiveStatus);
                        } else {
                            setIsActive(newActiveStatus);
                        }
                        message.success(`Template ${statusText}d successfully.`);
                    }
                } catch (e) {
                    message.error(`Failed to ${statusText} the template. Please try again.`);
                }
            },
        });
    };

    return (
        <div className='customSwitch'>
            <Switch
                className="template-switch"
                checked={isActive}
                onChange={handleToggle}
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                title={templateData?.isActive ? 'Deactivate Template' : 'Activate Template'}
            />
        </div>
    );
};

export default TemplateActiveToggle;